import { render, staticRenderFns } from "./PrizeSelect.vue?vue&type=template&id=3b9c77c7&scoped=true"
import script from "./PrizeSelect.vue?vue&type=script&lang=js"
export * from "./PrizeSelect.vue?vue&type=script&lang=js"
import style0 from "./PrizeSelect.vue?vue&type=style&index=0&id=3b9c77c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c77c7",
  null
  
)

export default component.exports